module.exports = __webpack_public_path__ + "static/img/vieux.224cfc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/vieux.jpg
// module id = 39
// module chunks = 0